// @flow

/**
 * Data Display Renderer
 * Strategy pattern: maps displayType to the appropriate display component.
 * To add a new display type, add an entry to DISPLAY_REGISTRY.
 */

import React from 'react';
import ComposedGraphDisplay from './displays/ComposedGraphDisplay';
import TableDisplay from './displays/TableDisplay';
import DataDisplayPlaceholder from './DataDisplayPlaceholder';

const DISPLAY_REGISTRY = {
  composedGraph: ComposedGraphDisplay,
  table: TableDisplay,
};

type Props = {
  definition: Object,
  displayId?: string,
};

const DataDisplayRenderer = ({ definition, displayId }: Props) => {
  const DisplayComponent = DISPLAY_REGISTRY[definition.displayType];

  if (!DisplayComponent) {
    return (
      <DataDisplayPlaceholder
        message={`Unsupported display type: ${definition.displayType}`}
      />
    );
  }

  return <DisplayComponent definition={definition} displayId={displayId} />;
};

export default DataDisplayRenderer;
